export default __webpack_public_path__ + "static/media/SciencePort List of Services.3a7ba13b.pdf";